import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceSatisfied"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM7.25 7.25008C5.86929 7.25008 4.75 8.36937 4.75 9.75008C4.75 11.1308 5.86929 12.2501 7.25 12.2501C8.63071 12.2501 9.75 11.1308 9.75 9.75008C9.75538 9.0854 9.49372 8.44639 9.02371 7.97638C8.55369 7.50636 7.91468 7.2447 7.25 7.25008ZM16.25 7.25008C14.8693 7.25008 13.75 8.36937 13.75 9.75008C13.75 11.1308 14.8693 12.2501 16.25 12.2501C17.6307 12.2501 18.75 11.1308 18.75 9.75008C18.7554 9.0854 18.4937 8.44639 18.0237 7.97638C17.5537 7.50636 16.9147 7.2447 16.25 7.25008ZM18.6 16.3601C17.1575 18.769 14.5578 20.2453 11.75 20.2501C8.94224 20.2453 6.34249 18.769 4.9 16.3601L6.61 15.3601C7.69547 17.1626 9.64585 18.2649 11.75 18.2649C13.8541 18.2649 15.8045 17.1626 16.89 15.3601L18.6 16.3601ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceSatisfied.vue"]]);
